module.exports = __webpack_public_path__ + "img/main_culture7.49e6d491.png";